import styles from "../styles/ui/Welcome.module.css";
import logo from "../asset/Images/cryptocrispyLogo.png";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Welcome() {
    return (
        <>
            <div className={styles.logoContainer}>
                <div className={styles.logo}>
                    <LazyLoadImage
                        src={logo}
                        alt="cryptocrispyLogo"
                        width="103px"
                        height="46px"
                        effect="blur"
                    />
                </div>
                <div className={styles.loader}></div>
            </div>
            <div className={styles.welcomeText}>
                <p>WELCOME TO CRYPTOCRISPY</p>
            </div>
        </>
    );
}

export default Welcome;